import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface StickyCtaProps {
  label: string;
  hint: string;
  buttonLabel: string;
  href: string;
}
export function StickyCta({
  label,
  hint,
  buttonLabel,
  href
}: StickyCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.9;
      const nearEnd = window.scrollY + window.innerHeight > document.body.scrollHeight - window.innerHeight * 0.6;
      setVisible(past && !nearEnd);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-82" data-mp="1c7djqc3dlycj">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-carbon/95 backdrop-blur-sm" data-id="element-83" data-mp="1c8f79g1kwdb5">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-3 px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:gap-4 sm:px-5 sm:py-3.5 md:px-8" data-id="element-84" data-mp="ae7bgw05pjyx">
            <div className="min-w-0" data-id="element-85" data-mp="jdc9803w99a1">
              <p className="truncate font-serif text-[14px] font-semibold text-ivory sm:text-[15px] md:text-[17px]" data-id="element-86" data-mp="3rsm9d2o844f6">
                {label}
              </p>
              <p className="hidden truncate font-mono text-[10px] tracking-[0.1em] text-ash/80 sm:block" data-id="element-87" data-mp="3mv49e1s6ozjb">
                {hint}
              </p>
            </div>
            <a href={href} rel="noopener" className="group flex shrink-0 items-center gap-2 rounded-sm bg-gold px-3.5 py-3 font-mono text-[9.5px] font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-200 hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-carbon sm:px-4 sm:text-[10.5px] sm:tracking-[0.14em] md:text-[11.5px]" data-id="element-88" data-mp="m1knpln58lb">
              {buttonLabel}
              <ArrowRight aria-hidden="true" className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" data-id="element-89" data-mp="1hr00u85pr9w7" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}